import { atom } from 'jotai';

const lastInsightsClickAtom = atom(null);

export default lastInsightsClickAtom;
